
<!-- <fieldset [disabled]="isLoading">
  <div [hidden]="!error" class="alert alert-danger">
    {{ error }}
  </div>
    <form (ngSubmit)="login()" [formGroup]="loginForm">
      <div class="form-group">
        <label class="d-block"><span>Username</span>
          <input type="text" class="form-control" [placeholder]="'Username'" formControlName="username">
          <app-control-messages [control]="f['username']"></app-control-messages>
        </label>
      </div>
      <div class="form-group">
        <label class="d-block"><span>Password</span>
          <input type="password" class="form-control" [placeholder]="'Password'" formControlName="password">
          <app-control-messages [control]="f['password']"></app-control-messages>
        </label>
      </div>
      <div class="form-group">
        <button  type="submit" class="btn btn-primary btn-block btn-raised" type="submit" [disabled]="loginForm.invalid">
          <span [hidden]="isLoading">Submit</span>
          <span [hidden]="!isLoading">
            <fa-icon icon="asterisk" size="3x" [spin]="true"></fa-icon>
          </span>
        </button>
      </div>
      <div style="text-align: center;"><a [routerLink]="['/auth/forgot']">Forgot Userame or Password?</a></div>
  </form>
</fieldset>  -->

<div id="okta-signin-container"></div>

